import { Action, createReducer, on } from '@ngrx/store';
import { setTrackingAction } from '@app/store/actions/global.actions';

export interface TrackingState {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
}

export const initialTrackingState: TrackingState = {} as TrackingState;

const featureReducer = createReducer(
  initialTrackingState,
  on(setTrackingAction, (state, { tracking }) => {
    return { ...state, ...tracking };
  })
);

export const trackingReducer = (state: TrackingState, action: Action): TrackingState => {
  return featureReducer(state, action);
};
